import * as React from "react";

interface ProgressBarProps {
  percentage: number;
}

class ProgressBar extends React.Component<ProgressBarProps, {}> {
  render() {
    return (
      <div className="velaro-progress-bar">
        <div
          className="velaro-progress-bar-inner"
          style={{ width: `${this.props.percentage}%` }}
        />
      </div>
    );
  }
}

export default ProgressBar;
